import './ccf-working-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfWorkingIconProps extends SvgIconProps  {}
/**
 * component used to display working icon in agent state
 * @param props - CcfWorkingIconProps
 * @example - <CcfWorkingIcon />
 * @returns SVG of working icon in agent state
 */
export function CcfWorkingIcon(props: CcfWorkingIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_working" clipPath="url(#clip-ic_working)">
        <g id="ic_working-2" data-name="ic_working" transform="translate(4 4)">
          <circle
            id="Ellipse_4745"
            data-name="Ellipse 4745"
            cx="8.5"
            cy="8.5"
            r="8.5"
            fill="#ffb000"
          />
          <circle
            id="Ellipse_4762"
            data-name="Ellipse 4762"
            cx="3.5"
            cy="3.5"
            r="3.5"
            transform="translate(5 5)"
            fill="#fff"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfWorkingIcon;
